import { Box, LinearProgress } from '@mui/material';
import React from 'react';

export const Loading: React.FC<{ activity: boolean }> = ({ activity }) => {
    return activity ? (
        <React.Fragment>
            <Box
                sx={{
                    width: '100%',
                    color: '#0085CA',
                    position: 'absolute',
                    zIndex: 10000000000,
                    top: 0,
                }}
            >
                <LinearProgress color="inherit" />
            </Box>
            <Box
                sx={{
                    width: '100%',
                    color: '#0085CA',
                    position: 'absolute',
                    bottom: 0,
                }}
            >
                <LinearProgress color="inherit" />
            </Box>
        </React.Fragment>
    ) : null;
};
